<template>
  <div>
    <p class="text--secondary text-center mb-5">
      {{ widgetContent.title }}
    </p>

    <form v-on:submit.prevent="submitHandler">
      <div class="form-group mb-4">
        <v-text-field
          :label="$t('lobby.contactRequestForm.input1.label')"
          :placeholder="$t('lobby.contactRequestForm.input1.placeHolder')"
          required
          type="text"
          v-model="form.name"
          outlined
          dense
          persistent-placeholder
          class="os-rounded"
          maxlength="50"
          :hide-details="!errorIndex(0)"
          :error-messages="errorMessage(3, $t('lobby.contactRequestForm.input1.label'), 0)"
          :error="errorIndex(0)"
          @blur="validateFields(form.name, 3, 0)"
        ></v-text-field>
      </div>

      <div class="form-group mb-4">
        <v-text-field
          :label="$t('lobby.contactRequestForm.input2.label')"
          :placeholder="$t('lobby.contactRequestForm.input2.placeHolder')"
          required
          type="text"
          v-model="form.email"
          outlined
          dense
          persistent-placeholder
          class="os-rounded"
          maxlength="50"
          :hide-details="!errorIndex(1)"
          :error-messages="errorMessage(5, $t('lobby.contactRequestForm.input2.label'), 1)"
          :error="errorIndex(1)"
          @blur="validateFields(form.email, 5, 1)"
        ></v-text-field>
      </div>

      <v-row class="ma-0 pa-0 mb-4">
        <v-col class="ma-0 pa-0" cols="5">
          <v-select
            :label="$t('lobby.contactRequestForm.input3.label')"
            v-model="form.countryCode"
            :items="countries"
            item-text="nameCode"
            item-value="dial_code"
            outlined
            hide-details
            persistent-placeholder
            required
            dense
            class="me-1 os-rounded"
          ></v-select>
        </v-col>
        <v-col class="ma-0 pa-0" cols="7">
          <v-text-field
            :label="$t('lobby.contactRequestForm.input4.label')"
            :placeholder="$t('lobby.contactRequestForm.input4.placeHolder')"
            required
            type="number"
            v-model="form.cellphone"
            outlined
            persistent-placeholder
            dense
            class="os-rounded"
            maxlength="15"
            :hide-details="!errorIndex(2)"
            :error-messages="errorMessage(7, $t('lobby.contactRequestForm.input4.label'), 2)"
            :error="errorIndex(2)"
            @blur="validateFields(form.cellphone, 7, 2)"
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="form-group mb-4">
        <v-textarea
          :label="$t('lobby.contactRequestForm.input5.label')"
          :placeholder="$t('lobby.contactRequestForm.input5.placeHolder')"
          type="text"
          v-model="form.observation"
          outlined
          dense
          persistent-placeholder
          rows="2"
          class="os-rounded"
          maxlength="255"
          :hide-details="!errorIndex(3)"
          :error-messages="errorMessage(6, $t('lobby.contactRequestForm.input5.label'), 3)"
          :error="errorIndex(3)"
          @blur="validateFields(form.observation, 6, 3, false)"
        ></v-textarea>
      </div>

      <v-row>
        <v-col cols="12">
          <v-btn
            v-if="btnPrimaryConfig.data"
            class="font-weight-bold os-rounded"
            type="submit"
            block
            elevation="0"
            :color="btnPrimaryConfig.data.btn"
            :style="`color: ${btnPrimaryConfig.data.text}`"
            :loading="button.submit.loading"
            :disabled="button.submit.disabled"
          >
            {{ $t('lobby.contactRequestForm.submit') }}
          </v-btn>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/MainService'
import countries from '@/resources/json/countries.json'

require('@/plugins/FormErrorValidator')

@Component({
  computed: {
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    },
    category () {
      return this.$store.state.storage.category
    },
    customer () {
      return this.$store.state.storage.room.customer
    },
    widgetContent () {
      const config = this.$organization.widgetContent()

      return {
        title: config?.data?.lobby?.contact_request_form?.title ?? config.defaultData.lobby.contact_request_form.title
      }
    }
  }
})
export default class ContactRequestForm extends Vue {
  data () {
    return {
      form: {
        name: null,
        email: null,
        countryCode: '+56',
        cellphone: null,
        observation: ''
      },
      countries,
      button: {
        submit: {
          loading: false,
          disabled: false
        }
      },
      validateError: {},
    }
  }

  errorMessage (typeId, question, index) {
    if (this.validateError[index]?.error) return this.validateError[index]?.message
  }

  errorIndex (index) {
    return this.validateError[index]?.error;
  }

  validateFields (value, typeId, index, required = true) {
    if (!value && !required) {
      this.$set(this.validateError, index, { error: false, message: null })
      return false
    }

    let { error, message } = this.$FormErrorValidator.validateFields(value, typeId);
    this.$set(this.validateError, index, { error, message })
  }

  validateBeforeSubmit() {
    this.validateFields(this.form.name, 3, 0)
    this.validateFields(this.form.email, 5, 1)
    this.validateFields(this.form.cellphone, 7, 2)
    this.validateFields(this.form.observation, 6, 3, false)

    for (let key in this.validateError) {
      if (this.validateError[key] && this.validateError[key]?.error) {
        return true
      }
    }
  }

  mounted () {
    this.setFormData()
    this.listCountryCodeAndName()
  }

  setFormData () {
    this.form.name = this.customer?.name ?? null
    this.form.email = this.customer?.email ?? null
    this.form.countryCode = this.customer?.countryCode ?? '+56'
    this.form.cellphone = this.customer?.cellphone ?? null
  }

  listCountryCodeAndName () {
    for (let index = 0; index < this.countries.length; index++) {
      const country = this.countries[index]
      country.nameCode =  `${country.dial_code} - ${country.name}`
    }

    this.countries.sort((a, b) => {
      return  (a.name > b.name) ? 1 : (a.name < b.name) ? -1 : 0
    })
  }

  toggleSubmitButton () {
    this.button.submit.loading = !this.button.submit.loading
    this.button.submit.disabled = !this.button.submit.disabled
  }

  async submitHandler () {
    if (this.validateBeforeSubmit()) return false

    const data = {
      route: 'ocular/widget/contact-request',
      params: {
        name: this.form.name,
        email: this.form.email,
        phone: `${this.form.countryCode}${this.form.cellphone}`,
        observation: this.form.observation,
        category_id: this.category?.id,
        origin_url: Vue.prototype.$widget.urlOrigin() 
      }
    }

    this.toggleSubmitButton()

    return MainService.post(data)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          this.$router.replace({ path: '/thank-you-page', query: { contactRequest: true } })
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.toggleSubmitButton()
      })
  }
}
</script>
